import { useId } from "react";
import type { Perfil, Relacion } from "@/shared/api";
import { t } from "@/shared/i18n";
import { Selector } from "@/shared/ui";
import estilos from "./Usuarios.module.css";

const PERFILES: readonly Perfil[] = ["operaciones", "finanzas"];
const RELACIONES: readonly Relacion[] = ["propia", "mismo_grupo", "agente_aduanas", "casa_matriz", "otra"];

/** Perfil con la explicación de qué ve cada uno: es la decisión que más importa al invitar. */
export function ElegirPerfil({
  leyenda,
  valor,
  alCambiar,
}: {
  readonly leyenda: string;
  readonly valor: Perfil;
  readonly alCambiar: (p: Perfil) => void;
}) {
  const nombre = useId();
  return (
    <fieldset className={estilos.perfiles}>
      <legend>{leyenda}</legend>
      {PERFILES.map((p) => (
        <label key={p} className={estilos.perfil}>
          <input
            type="radio"
            name={nombre}
            value={p}
            checked={valor === p}
            onChange={() => {
              alCambiar(p);
            }}
          />
          <b>{t.perfiles[p]}</b>
          <span className={estilos.suave}>
            {p === "finanzas" ? t.perfiles.ayudaFinanzas : t.perfiles.ayudaOperaciones}
          </span>
        </label>
      ))}
    </fieldset>
  );
}

export function ElegirRelacion({
  valor,
  alCambiar,
}: {
  readonly valor: Relacion;
  readonly alCambiar: (r: Relacion) => void;
}) {
  return (
    <Selector
      rotulo={t.ficha.relacion}
      value={valor}
      opciones={RELACIONES.map((r) => ({ valor: r, texto: t.relaciones[r] }))}
      onChange={(e) => {
        alCambiar(e.target.value as Relacion);
      }}
    />
  );
}

export function SelectorPerfil({
  rotulo,
  valor,
  deshabilitado,
  alCambiar,
}: {
  readonly rotulo: string;
  readonly valor: Perfil;
  readonly deshabilitado?: boolean;
  readonly alCambiar: (p: Perfil) => void;
}) {
  return (
    <Selector
      rotulo={rotulo}
      rotuloOculto
      className={estilos.selectorPerfil}
      value={valor}
      disabled={deshabilitado}
      opciones={PERFILES.map((p) => ({ valor: p, texto: t.perfiles[p] }))}
      onChange={(e) => {
        alCambiar(e.target.value as Perfil);
      }}
    />
  );
}
